import { render, staticRenderFns } from "./sizeColor.vue?vue&type=template&id=6cbdee96"
import script from "./sizeColor.vue?vue&type=script&lang=js"
export * from "./sizeColor.vue?vue&type=script&lang=js"
import style0 from "./sizeColor.vue?vue&type=style&index=0&id=6cbdee96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports